<template>

  <div class="vx-row " >
    <div class="vx-col md:w-3/12 vx-card w-full mb-2"  >
      <div class="mt-6 ml-2">
        <span class="text-label-left" style="color: rgb(37 39 51)">{{$t('accountUser.list')}}</span>
      </div>
      <div class="vx-row ml-2 mt-10 cursor-pointer" @click="addAccount">
        <feather-icon
          icon="PlusCircleIcon"
          class="float-left ml-3 hover:text-success"
          style="color: rgb(185 185 195);width: 1.5rem"
          @click="addAccount"
        >
        </feather-icon>
        <span class="mt-1 ml-1" style="color: rgb(185 185 195);font-size: 12pt">{{$t('accountUser.addList')}}</span>
      </div>
      <div class="component mt-4">
        <div class="mt-2 cursor-pointer" v-for="(item,index) in user" :key="index" >
          <vs-button :class="{back : item.checked}" @click="filterInfo(item,index)" class="mt-2 btn-style w-full text-left" color="primary" type="border" >
            <div class="vx-row">
            <span class="mr-2">
              <img v-if="item.img" key="onlineImg" :src="item.img" alt="user-img" width="20" height="20" class="rounded-full shadow-md cursor-pointer block" />
              <img v-else key="onlineImg" :src="userInfo.photoURL" alt="user-img" width="20" height="20" class="rounded-full shadow-md cursor-pointer block" />
            </span>
              <span class="button-style">{{item.fullName}}</span>
            </div>
          </vs-button>
        </div>
      </div>
    </div>
    <div class="vx-col md:w-9/12 w-full pr-0 mb-2">
      <vx-card class="p-6">
        <div class="vx-col">
        <span class="text-title">
          {{ $t('accountUser.account') }}
        </span>
        <!-- Avatar Row -->
        <div class="vx-col mt-4" >
          <div class="vx-row">
            <div class="vx-col md:w-1/2 w-full">
              <div class="vx-row">
                <div class="vx-col w-full">
                  <div class="flex flex-wrap items-center justify-end">
                    <label class="text-label-left">{{ $t('accountUser.displayName') }}</label>
                    <label class="ml-auto text-label-right">{{ $t('accountUser.desDisplayName') }}</label>
                  </div>
                  <vs-input class="w-full" v-model="user.fullName" v-validate="'required|alpha_num'" name="fullName"
                            readonly/>
                </div>
              </div>
            </div>
            <div class="vx-col md:w-1/2 w-full">
              <div class="vx-row">
                <div class="vx-col w-full">
                  <div class="flex flex-wrap items-center justify-end">
                    <label class="text-label-left">{{ $t('accountUser.organizationName') }}</label>
                    <label class="ml-auto text-label-right">{{ $t('accountUser.desOrganizationName') }}</label>
                  </div>
                  <vs-input class="w-full" v-model="user.organizationName" v-validate="'required|alpha_num'"
                            name="organizationName" readonly/>
                </div>
              </div>
            </div>
          </div>
          <hr class="mt-8 opacity-50">
          <div class="vx-col mt-4">
            <div class="vx-row ">
              <div class="vx-col md:w-1/2 w-full">
                <div class="vx-row">
                  <div class="vx-col w-full">
                    <div class="flex flex-wrap items-center justify-end">
                      <label class="text-label-left">{{ $t('accountUser.email') }}</label>
                      <label class="ml-auto text-label-right">{{ $t('accountUser.desEmail') }}</label>
                    </div>
                    <vs-input class="w-full" v-model="user.email" v-validate="'required|alpha_num'" name="email"
                              readonly/>
                  </div>
                </div>
              </div>
              <div class="vx-col md:w-1/2 w-full">
                <div class="vx-row">
                  <div class="vx-col w-full">
                    <div class="flex flex-wrap items-center justify-end">
                      <label class="text-label-left">{{ $t('accountUser.phoneNumber') }}</label>
                      <label class="ml-auto text-label-right">{{ $t('accountUser.desPhoneNumber') }}</label>
                    </div>
                    <vs-input class="w-full" v-model="user.phoneNumber" v-validate="'required|alpha_num'"
                              name="phoneNumber" readonly/>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <hr class="mt-8 opacity-50">
        <div class="vx-col">
          <div class="text-avt mt-6">
            {{ $t('accountUser.editPassword') }}
          </div>
          <div class="text-label-right">
            <p>{{ $t('accountUser.desEditPassword') }}</p>
          </div>
          <div class="vx-col mt-4">
            <div class="flex flex-wrap items-center justify-end">
              <label class="text-label-left">{{ $t('accountUser.addPassword') }}</label>
              <vs-button  @click="changePassword" class="ml-auto">{{ $t('accountUser.add') }}</vs-button>
            </div>
          </div>
        </div>
        <hr class="mt-8 opacity-50">
        <div class="vx-col">
          <div class="text-avt mt-6">
            {{ $t('accountUser.deleteAccount') }}
          </div>
          <div class="vx-row w-full">
            <div class="vx-col md:w-10/12 w-full text-label-right">
              <p>{{ $t('accountUser.desDeleteAccount') }}</p>
            </div>
            <div class="vx-col md:w-2/12 w-full text-label-right" @click="confirmDeleteRecord">
              <vs-button type="border" color="danger" style="float: right;margin-right: -27px;">
                {{ $t('accountUser.delete') }}
              </vs-button>
            </div>
          </div>
        </div>
      </div>
      </vx-card>

    </div>
    <vs-popup :title="$t('accountUser.titlePassword')" :active.sync ="activePopupPassword">
      <div class="vx-col">
        <div class="vx-row">
          <div class="vx-col  w-full mt-2">
            <vs-input
              v-validate="'required|min:6'"
              data-vv-validate-on="blur"
              type="password"
              name="oldPassword"
              :label="this.$t('oldPassword')"
              v-model="user.oldPassword"
              autocomplete="off"
              class="w-full"/>
            <span class="text-danger text-sm">{{
                errors.first("oldPassword")
              }}</span>
          </div>
        </div>

        <div class="vx-row">
          <div class="vx-col  w-full mt-2">
            <div class="flex flex-wrap items-center justify-end">
              <label style="font-size: 9pt">{{$t('accountUser.newPassword')}}</label>
              <label class="ml-auto text-label-right" style="font-size: 8.5pt">{{$t('accountUser.desNewPassword')}}</label>
            </div>
            <vs-input
              v-validate="'required|min:6'"
              data-vv-validate-on="blur"
              type="password"
              name="password"
              v-model="user.newPassword"
              autocomplete="off"
              class="w-full"/>
            <span class="text-danger text-sm">{{
                errors.first("password")
              }}</span>
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col  w-full mt-2">
            <vs-input
              v-validate="{required: false, is: user.newPassword, min: 6}"
              data-vv-validate-onf="blur"
              type="password"
              name="rePassword"
              :label="this.$t('accountUser.confirmPass')"
              v-model="user.rePassword"
              autocomplete="off"
              class="w-full"/>
            <span class="text-danger text-sm">{{
                errors.first("rePassword")
              }}</span>
          </div>
        </div>
      </div>
      <div class="vx-row mt-4 text-size">
        <div class="vx-col w-full">
          <div class="mt-4 mb-4 flex flex-wrap items-center justify-start">
            <vs-button class=" mt-2 " icon-pack="feather" icon="icon" @click="saveChanges">{{$t('accountUser.saveChanges')}}
            </vs-button>
            <vs-button class="ml-4 mt-2" color="danger" icon-pack="feather" @click="activePopupPassword = false" icon="icon" type="border">{{$t('accountUser.close')}}
            </vs-button>
          </div>
        </div>
      </div>
    </vs-popup>
    <PopupConfirm :active="activePopup" :on-success="onSuccess" :close="closePopup"/>
  </div>
</template>

<script>
import PopupConfirm from "../../notify/PopupConfirm";

export default {
  components:{
    PopupConfirm
  },
  props:{
    id:null
  },
  data(){
    return {
      userInfo : [],
      confirmDelete:false,
      activePopup:false,
      activePopupPassword : false,
      checked : false,
      user : {
        fullName:null,
        organizationName:null,
        email:null,
        phoneNumber:null
      },
      idAccount:null,
      userSeleted:[]
    }
  },
  watch: {
  },

  methods:{
    changePassword() {
      this.activePopupPassword = true;
    },
    async saveChanges(evt) {
      evt.preventDefault();
      let path = '/user/change-password';
      let userRequest = this.user;
      this.$vs.loading();
      this.$oauth.post(path, userRequest).then((response) => {
        this.activePopupPassword = false;

        this.$vs.loading.close();
        this.$vs.notify({
          color: 'primary',
          text: this.$t('accountUser.updatePassword'),
          iconPack: 'feather',
          icon: 'icon-alert-circle',
        });
        this.$oauth.get('/user/current').then((response) => {
          let userInfo = response.data;
          userInfo.userRole = this.getRole(userInfo.roles[0].role);
          this.$store.dispatch('updateUserInfo', userInfo);
        })

      }).catch((err) => {
        this.$vs.loading.close();
        return this.$vs.notify({
          text: err.response.data.message || err.response.data.error_description || err.response.data.error,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        });
      });
    },

    addAccount: function () {
      this.$router.push('/user/account-user-info').catch(() => {
      })
    },
    filterInfo : function (item,index) {
      for (let i= 0;i< this.user.length;i++){
        this.user[i].checked=false;
      }
      this.idAccount = item.id
      item.checked = true
      this.user.fullName = this.user[index].fullName;
      this.user.organizationName = this.user[index].organizationName;
      this.user.email = this.user[index].email;
      this.user.phoneNumber = this.user[index].phoneNumber;

    },
    confirmDeleteRecord() {
      this.activePopup = true;
      this.confirmDelete = true;
    },
    closePopup(){
      this.activePopup = false;
      this.confirmDelete = false;
    },
    onSuccess(){
      if (this.confirmDelete){
        this.deleteRecord();
        this.confirmDelete = false;
      }
    },
    getImage: function(){
      this.userInfo = Object.assign({}, this.$store.state.AppActiveUser, JSON.parse(localStorage.getItem('userInfo')));
      const data = localStorage.getItem('userInfo');
      const info = JSON.parse(data);
      if(info.img){
        this.userInfo.img = info.img;
      }
    },
    deleteRecord() {
      if(this.idAccount == this.user[0].id) {
        this.confirmDelete =false;
        this.activePopup = false;
        this.$vs.notify({
          color: 'danger',
          text: this.$t('accountUser.doNotDelete'),
          iconPack: 'feather',
          icon: 'icon-alert-circle',
        })
      } else {
        this.$vs.loading();
        this.$oauth.post(`/user/delete/${this.idAccount}`).then(() => {
          this.confirmDelete =false;
          this.activePopup = false;
          this.$vs.loading.close();
          this.$vs.notify({
            color: 'primary',
            text: this.$t('accountUser.deleteAccountSuccess'),
            iconPack: 'feather',
            icon: 'icon-alert-circle',
          })
          this.getListAccount();
        }).catch((err) => {
          this.$vs.loading.close();
          this.getListAccount();
          return this.$vs.notify({
            text: err.response.data.message || err.response.data.error_description || err.response.data.error,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          });
        });
      }
      this.$vs.loading.close();
      this.activePopup = false;
      this.confirmDelete = false;
    },
    getListAccount(){
      this.$oauth.post('/user/organization/all',{}).then((res) => {
        this.user = res.data;
        this.user = this.user.map(el => {
          return{
            fullName : el.fullName,
            phoneNumber : el.phoneNumber,
            email : el.email,
            organizationName : el.organization.organizationName,
            id:el.id,
            img : el.img,
            checked: false
          }
        })
        this.user[0].checked=true;
        this.userSeleted = this.user ;
        this.user.fullName = this.user[0].fullName;
        this.user.organizationName = this.user[0].organizationName;
        this.user.email = this.user[0].email;
        this.user.img = this.user[0].img;
        this.user.phoneNumber = this.user[0].phoneNumber;
        this.idAccount = this.user[0].id;
      })
      this.$vs.loading.close();
    }
  },
  created() {
    this.getListAccount();
    this.getImage()
  },
  initScreen() {
    this.$vs.loading();
    this.$oauth.post('/user/organization/all',{}).then((response) => {
      this.userList = response.data.slice(1,response.data.length);
      this.$vs.loading.close();
      setTimeout(() => {
        if (this.$store.state.windowWidth > 1024) {
          this.gridApi.sizeColumnsToFit();
        }
      }, 100);
    }).catch((err) => {
      this.$vs.loading.close();
      return this.$vs.notify({
        text: err.response.data.message || err.response.data.error_description || err.response.data.error,
        iconPack: 'feather',
        icon: 'icon-alert-circle',
        color: 'danger'
      });
    });
  },

}
</script>

<style scoped>
.button-style{
  font-size: 15px;
  font-weight: bold;
}
.btn-style{
  /* padding: 12px 10px !important; */
  border: none;
  color: #626262;

}

.back{
  background-color: #2F80ED !important;
  color: white !important;
}
.text-title {
  font-size: 24px;
  font-weight: bold;
  color: rgb(94 88 115);
}

.text-avt {
  font-size: 16px;
  font-weight: bold;
  color: rgb(94 88 115);
}

.text-label-left {
  font-size: 12px;
  font-weight: bold;
  color: rgb(94 88 115);
}

.text-label-right {
  font-size: 12px;
  color: #C1BEC1;
}
</style>
